import styled from "styled-components";

export const StyledUnitsPage = styled.div`
	width: 100%;
	& > div {
		margin-top: 1rem;
	}

	& button {
		margin-top: 2rem;
	}
`;
